/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import classnames from 'classnames';
import { range } from 'ramda';
import React, { useRef, useState } from 'react';

import { useOnClickOutside } from '../../utils/useOnClickOutside';

interface YearDropdownOptionsProps {
  minYear?: number;
  maxYear?: number;
  onChange: (month: number) => void;
  onCancel: () => void;
  currentYear: number;
}

const VISIBLE_YEARS_FOR_EACH_DIRECTION = 5;

export const getMinRangeYear = (currentYear: number, minYear?: number) => {
  const possibleMinYear = currentYear - VISIBLE_YEARS_FOR_EACH_DIRECTION;
  if (minYear && possibleMinYear < minYear) {
    return minYear;
  }

  return possibleMinYear;
};
export const getMaxRangeYear = (currentYear: number, maxYear?: number) => {
  const possibleMaxYear = currentYear + VISIBLE_YEARS_FOR_EACH_DIRECTION;
  if (maxYear && possibleMaxYear > maxYear) {
    return maxYear;
  }

  return possibleMaxYear;
};

export const YearDropdownOptions: React.FC<YearDropdownOptionsProps> = ({
  currentYear,
  minYear,
  maxYear,
  onChange,
  onCancel,
}) => {
  const defaultYearsList = range(
    getMinRangeYear(currentYear, minYear),
    getMaxRangeYear(currentYear, maxYear) + 1 // +1 because range(a, b) is equivalent to the half-open interval [a, b)
  ).reverse();
  const [yearsList, setYearsList] = useState(defaultYearsList);
  const dropdownRef = useRef(null);
  useOnClickOutside(dropdownRef, () => onCancel());

  const shiftYears = (amount: number) => {
    const newYearsList = yearsList.map((year) => year + amount);
    setYearsList(newYearsList);
  };

  const Option = (year: number, isSelected: boolean) => (
    <div
      className={classnames('react-datepicker__year-option', {
        'react-datepicker__year-option--selected_year': isSelected,
      })}
      data-test-id={`datepicker-year-option:${year}`}
      key={year}
      onClick={() => onChange(year)}
    >
      {isSelected && <span className="react-datepicker__year-option--selected">✓</span>}
      {year}
    </div>
  );

  const navigationClasses = 'react-datepicker__navigation react-datepicker__navigation--years mt-0';

  const ArrowUp = () => (
    <div
      className="react-datepicker__year-option"
      data-test-id="navigation-years-upcoming"
      onClick={() => shiftYears(1)}
    >
      <a className={classnames(navigationClasses, 'react-datepicker__navigation--years-upcoming')} />
    </div>
  );

  const ArrowDown = () => (
    <div
      className="react-datepicker__year-option"
      data-test-id="navigation-years-previous"
      onClick={() => shiftYears(-1)}
    >
      <a className={classnames(navigationClasses, 'react-datepicker__navigation--years-previous')} />
    </div>
  );

  return (
    <div className="react-datepicker__year-dropdown" ref={dropdownRef} data-test-id="year-dropdown-options">
      {(!maxYear || yearsList[0] < maxYear) && <ArrowUp />}
      {yearsList.map((year) => Option(year, currentYear === year))}
      {(!minYear || yearsList[yearsList.length - 1] > minYear) && <ArrowDown />}
    </div>
  );
};
